import { useEffect, useRef } from 'react';
/**
 * A React hook that sets up an interval to run the provided callback.
 *
 * The callback is always the latest version passed to the hook, even if it changes between renders.
 * The interval is cleared and reset when `delayMillis` changes.
 *
 * @param fn - The callback function to be invoked on each interval tick.
 * @param delayMillis - The delay in milliseconds between executions.
 *                      If `undefined`, the interval is not set (previous one stops).
 *
 * @example
 * useIntervalEffect(() => {
 *   console.log('Tick');
 * }, 1000);
 */
export function useIntervalEffect(fn, delayMillis) {
    const fnRef = useRef(fn);
    fnRef.current = fn;
    useEffect(() => {
        if (delayMillis == null) {
            return;
        }
        const intervalId = window.setInterval(() => {
            fnRef.current();
        }, delayMillis);
        return () => {
            window.clearInterval(intervalId);
        };
    }, [delayMillis]);
}
